import { Amount, dropsToXrp } from 'xrpl';
import { DECIMAL_PLACES } from '../constants';
import { isString } from './typeof-fns';

/**
 * Get the value of an offer and format it to the decimal places
 * @param val IssuedCurrency or string
 * @returns A string formatted to the decimal places for IOU or the XRP amount (not drops)
 */
export const extractAmountValue = (val: Amount) =>
  isString(val) ? dropsToXrp(val) : Number(val.value).toFixed(DECIMAL_PLACES);
